import React, { useContext, useEffect } from "react";
import { useStore } from "../../context/store.provider";
// here need to show the whole information from the cartOrderForm on any client order
import "./ClientsOrders.css";
import emailjs from "emailjs-com";
import { storeContext } from "../../context/context";
import {
  getOrders,
  orderCollectionRef,
  updateOrder,
} from "../user/GettingData/firebase";
import { useState } from "react";
import { getDocs } from "firebase/firestore";
import { async } from "@firebase/util";

function ClientsOrders() {
  const { orders, clients, choosenProducts, storeProducts } = useStore();
console.log(orders);
  function sendEmail(e) {
    e.preventDefault();
    console.log(e);
    //     console.log(order,id)
    //     // here need to update the order to be completed true
    // const updatedOrder= {...order,completed:true}
    //     updateOrder(id,updatedOrder)
    emailjs
      .sendForm(
        "service_wowl35g",
        "template_aun3ryd",
        e.target,
        "8YimBpcQB1ncS328P"
      )
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );
  }
  const completedOrder = async (id) => {
    const completed = {completed:true}
    updateOrder(id,completed);
  };
  // useEffect(() => {
  //   const getOrders = async () => {
  //     const data = await getDocs(orderCollectionRef);
  //     setOrders(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
  //   };
  //   getOrders()

  // }, []);

  // orders.map(({order,id})=>(
  // console.log(order,id,order.products)
  // ))
  // here need to loop on the array first time to
  return (
    <div className="clients-orders">
      <div className="client-card">
        <div className="client-details-card">
          {orders?.map(({ completed, order, id }) => {
            if (!completed) {
              console.log(order.completed);
              return (
                <div key={id}>
                  <h3>client details</h3>
                  <div>name: {order.firstName}</div>
                  <div>last name: {order.lastName}</div>
                  <div> mail: {order.Email}</div>
                  <div>phone: {order.number}</div>
                  {order.products.map(
                    (
                      { category, imgUrl, price, productName, productAmount },
                      index
                    ) => (
                      <div key={index}>
                        <div>product name: {productName}</div>
                        <div>category: {category}</div>
                        <div>total price: {price}</div>
                        <div>{productAmount}</div>
                        <div className="client-order-details"></div>
                      </div>
                    )
                  )}
                  <div>סה"כ לתשלום: {order.totalOrderPrice}₪</div>
                  <form className="form-client" onSubmit={sendEmail}>
                    <textarea
                      resize="none"
                      id="massage-to-client"
                      name="massage"
                      rows="2"
                      cols="50"
                    ></textarea>
                    <input
                      hidden={true}
                      type="mail"
                      name="client"
                      value={order.Email}
                      readOnly
                    />
                    <button
                      onClick={() => completedOrder(id)}
                      type="submit"
                      className="btn-order-clients"
                    >
                      order completed
                    </button>
                  </form>
                </div>
              );
            } else {
              console.log(order);
              return <div>הזמנות אלו הושלמו</div>
            }
            // if the order not completed to show on screen
          })}
        </div>
        {/* <div className="oreder-details">
           {order.map(
            ({ category, imgUrl, price, productName, productAmount },index) => (
              <div key={index}>
                <h3>oreder-details </h3>
                <div>productName:{productName}</div>
                <div>category:{category}</div>
                <div>total price:{price}</div>
                <div>{productAmount}</div>
                <div className="client-order-details"></div>
              </div>
            )
          )} 
        </div> */}
      </div>
    </div>
  );
}

export default ClientsOrders;
